import { loader } from "./actions.tsx";
import ObserverPage from "./validate.tsx";

export default {
  path: "/link/observer/:code",
  loader,
  Component: ObserverPage,
};
